module.exports = __webpack_public_path__ + "img/flag_de.6e41aa3c.svg";